import $ from 'jquery';
import _ from 'lodash';
import Highcharts from 'highcharts';
import message from '../../../../../utils/message';

/*

 【ホームワーク】
 No,配信名,配信者名,クラス,開始日時,終了日時,修了率,完了人数,受講途中人数,未着手人数

 */

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  // ヘッダーを削除
  papa_data.data.shift();
  console.log(papa_data.data);
  let categories = [];
  let chart_labels = [];
  // クラス種別のリストを作成
  categories = _.map(papa_data.data, o => o[3]);
  categories = _.uniq(categories);

  // ホームワーク種別のリストを作成
  chart_labels = _.map(papa_data.data, o => o[1]);
  chart_labels = _.uniq(chart_labels);

  const chart_data = [];

  _.each(chart_labels, (label) => {
    const hwName = label;
    chart_data.push({
      name: hwName,
      data: _.map(categories, (o) => {
        const className = o;
        let shintyoku = 0;

        const hw = _.find(papa_data.data, row => row[1] === hwName && row[3] === className);

        if (hw === undefined) {
          shintyoku = '';
        } else {
          shintyoku = Number(hw[6].replace(/%/, '').replace(/ /, ''));
        }
        return shintyoku;
      }),
    });
  });

  console.log(chart_data);

  $csv_chart_area.highcharts({
    chart: {
      type: 'bar',
    },
    title: {
      text: null,
    },
    xAxis: {
      categories,
      title: {
        text: message.className,
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: `${message.completionRate} (%)`,
        align: 'high',
      },
      labels: {
        // overflow: 'justify',
      },
    },
    plotOptions: {
      bar: {
        // dataLabels: {
        //   enabled: true,
        // },
      },
    },
    series: chart_data,
  });
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/selectedtraining/assign_index.js